import type { ReactNode } from "react";

export function StatCard({
  icon,
  label,
  value,
  highlight = false,
}: {
  readonly icon: ReactNode;
  readonly label: string;
  readonly value: string;
  readonly highlight?: boolean;
}) {
  return (
    <div
      className={`rounded-xl border px-3.5 py-3 ${
        highlight ? "border-primary/30 bg-accent text-accent-foreground" : "border-border bg-card"
      }`}
    >
      <div
        className={`flex items-center gap-1.5 text-xs font-medium ${
          highlight ? "text-primary" : "text-muted-foreground"
        }`}
      >
        {icon}
        {label}
      </div>
      <div className="mt-1 text-2xl font-semibold tabular-nums">{value}</div>
    </div>
  );
}
